import React from 'react';
import { motion } from 'framer-motion';

interface OrbConfig {
  id: number;
  color: string;
  size: number;
  path: {
    x: number[];
    y: number[];
  };
}

const orbs: OrbConfig[] = [
  {
    id: 1,
    color: '#3B82F6', // Bright blue
    size: 300,
    path: {
      x: [5, 20, 10, 5], // Top left area - more inside
      y: [10, 20, 30, 10]
    }
  },
  {
    id: 2,
    color: '#10B981', // Emerald green
    size: 400,
    path: {
      x: [55, 70, 60, 55], // Right side - more inside
      y: [15, 5, 25, 15]
    }
  },
  {
    id: 3,
    color: '#F59E0B', // Amber orange
    size: 350,
    path: {
      x: [10, 25, 15, 10], // Bottom left - more inside
      y: [55, 65, 75, 55]
    }
  },
  {
    id: 4,
    color: '#8B5CF6', // Purple
    size: 250,
    path: {
      x: [60, 75, 65, 60], // Bottom right - more inside
      y: [60, 50, 70, 60]
    }
  },
];

export function AnimatedOrbs() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none">
      {orbs.map((orb) => (
        <motion.div
          key={orb.id}
          className="absolute rounded-full"
          style={{
            width: orb.size,
            height: orb.size,
            background: `radial-gradient(circle at center, ${orb.color}66 0%, ${orb.color}4D 30%, ${orb.color}33 60%, ${orb.color}1A 100%)`,
          }}
          initial={{ 
            left: `${orb.path.x[0]}%`,
            top: `${orb.path.y[0]}%`,
            scale: 0.8,
            opacity: 0
          }}
          animate={{
            left: orb.path.x.map(x => `${x}%`),
            top: orb.path.y.map(y => `${y}%`),
            scale: [0.8, 1.1, 0.9, 1, 0.8],
            opacity: [0, 0.8, 0.9, 0.7, 0.8, 0]
          }}
          transition={{
            left: {
              duration: 20 + orb.id * 5, // Different duration for each orb
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.33, 0.66, 1]
            },
            top: {
              duration: 20 + orb.id * 5,
              repeat: Infinity,
              ease: "easeInOut",
              times: [0, 0.33, 0.66, 1]
            },
            scale: {
              duration: 15 + orb.id * 3,
              repeat: Infinity,
              ease: "easeInOut"
            },
            opacity: {
              duration: 20 + orb.id * 5,
              repeat: Infinity,
              ease: "easeInOut"
            }
          }}
        />
      ))}
      
      {/* Mobile optimized orbs */}
      <div className="block md:hidden">
        <motion.div
          className="absolute rounded-full"
          style={{
            width: 200,
            height: 200,
            left: '-50px',
            top: '10%',
            background: `radial-gradient(circle at center, #3B82F666 0%, #3B82F64D 40%, #3B82F633 70%)`,
          }}
          animate={{
            x: [0, 100, 0],
            y: [0, 50, 0],
            scale: [1, 1.2, 1],
            opacity: [0.7, 0.8, 0.7],
          }}
          transition={{
            duration: 15,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
        <motion.div
          className="absolute rounded-full"
          style={{
            width: 250,
            height: 250,
            right: '-50px',
            bottom: '20%',
            background: `radial-gradient(circle at center, #10B98166 0%, #10B9814D 40%, #10B98133 70%)`,
          }}
          animate={{
            x: [0, -80, 0],
            y: [0, -60, 0],
            scale: [1, 1.15, 1],
            opacity: [0.7, 0.8, 0.7],
          }}
          transition={{
            duration: 18,
            repeat: Infinity,
            ease: "easeInOut"
          }}
        />
      </div>
    </div>
  );
}
